<template>
	<div id="userinfo" v-show="pageReady">
		<div class="userContent">
			<img
				:src="$auth.user.picture"
			/>
			<div>
				{{ $auth.user.name }}
			</div>
			<div
				class="btnBarcodeScan"
				@click="logout()"
			>
				ログアウト
			</div>
			<div class="contact">
				問い合わせ先：沼尻高原ロッジ<br>
				（運営：株式会社大川荘）<br>
				<a
					href="tel:0242-93-8101"
					class="contactLink"
				>
					0242-93-8101
				</a>
			</div>
			<div class="contact">
				フォームでの問い合わせは
				<a
					href="https://docs.google.com/forms/d/e/1FAIpQLSf5M6z7oGk_MnSo2J4_I5q-VFeGCd21uTXM1qZKUsi2LifEqQ/viewform"
					target="_blank"
					class="contactLink"
				>
					こちら
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
/* eslint-disable */
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'
// axios.defaults.withCredentials = true
/* eslint-enable */

export default {
	name: 'Userinfo',
	data () {
		return {
			pageReady: false
		}
	},
	watch: {
	},
	mounted () {
		this.$store.dispatch('Utility/dohideLoading')
		setTimeout(() => {
			this.pageReady = true
		}, 500)
	},
	methods: {
		async logout () {
			const message = 'ログアウトしますか？'
			if (window.confirm(message)) {
				await this.$auth.logout({
					returnTo: window.location.origin
				})
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
@import "~@/themes/styles/mixins.styl"

#userinfo
	text-align center
	.userContent
		margin-top 20%
		.btnBarcodeScan
			border-radius 10px
			width 55%
			margin 24px auto 0 auto
			padding 14px
			box-sizing border-box
			background main-light-dark
			transition all 0.2s ease-out 0s
			color white
			box-shadow 0 9px 18px
		img
			height 100px
			width 100px
			border-radius 100px
			margin-bottom 20px
		.contact
			margin-top 24px
			font-size 0.9rem
			.contactLink
				color blue-color
</style>
